import { Injectable } from '@angular/core';
import { EnvService } from '../env.service';
import { HttpHeaders, HttpRequest, HttpResponse } from '@angular/common/http';
import { of, delay } from 'rxjs';
import { values } from 'lodash-es';
import { urls } from './api-urls';

@Injectable({ providedIn: 'root' })
export class ApiMockService {
  constructor(private envService: EnvService) {}

  handleRequest(request: HttpRequest<any>) {
    for (const urlConfig of values(urls)) {
      const endpointRegex = new RegExp(urlConfig.endpointRegex(this.envService));
      const requestUrl = request.url.split('?')[0];
      const match = requestUrl.match(endpointRegex);

      let response: any = null;

      if (request.method === urlConfig.httpMethod && match && requestUrl === match[0]) {
        if (urlConfig.responseContentType === 'text/html') {
          response = new HttpResponse({
            status: 200,
            headers: new HttpHeaders({
              'Content-Type': 'text/html',
            }),
            body: urlConfig.mockSuccessData(match.groups, request.body),
          });
        } else if (urlConfig.mockResponse) {
          // TODO: fully parametrize mocks with (urlParams, queryParams, bodyParams)
          // TODO: support other properties in body
          const { responseHttpStatus, responseBody } = urlConfig.mockResponse(match.groups, request.body);
          response = new HttpResponse({
            // TODO Support error returns in mock layer
            status: responseHttpStatus,
            body: responseBody,
          });
        } else {
          response = new HttpResponse({
            status: 200,
            body: {
              // TODO: fully parametrize mocks with (urlParams, queryParams, bodyParams)
              // TODO: support other properties in body
              data: urlConfig.mockSuccessData(match.groups, request.body),
              messages: [],
              errors: [],
              success: true,
            },
          });
        }

        return of(response).pipe(delay(urlConfig.mockDelay || this.envService.api.mockDelay));
      }
    }

    return null;
  }
}
